Ext.define('SA.model.PackageDataRemovedNotice', {
    statics: {
        deserialize(notices) {
            return new SA.model.PackageDataRemovedNotice(getParams(notices));

            function getParams(notices) {
                return notices.reduce((params, notice) => {
                    var packageNames = notice.message.split(',').map(Ext.String.trim);

                    return {
                        ids: params.ids.concat(notice.user_notification_id),
                        packageNames: Ext.Array.merge(params.packageNames, packageNames)
                    };
                }, {ids: [], packageNames: []});
            }
        }
    },

    constructor(params) {
        this.ids = params.ids;
        this.packageNames = params.packageNames;
    },

    getPackageNames() {
        return this.packageNames;
    },

    markViewed() {
        SA.model.Notices.acknowledge({ids: this.ids});
    }
});